import Status from './status';
import Empty from './empty';

Status.Empty = Empty;

export default Status;
